<form
  [formGroup]="form"
  [mojoFormConnect]="job"
>

  <div class="mb-4">
    <label
      for="description"
      class="required"
    >
      Job description
    </label>
    <mojo-editor
      id="description"
      [material]="true"
      [expandable]="true"
      class="form-control-editor description"
      placeholder="Describe the role, day-to-day responsibilities and what success looks like for this job"
      formControlName="description"
      data-cy="job-description-description-editor"
    >
    </mojo-editor>
  </div>

  <div class="mb-4">
    <label
      for="highLevelRequirements"
      class="required"
    >
      Required qualifications and skills
    </label>
    <mojo-editor
      id="highLevelRequirements"
      [material]="true"
      [expandable]="true"
      class="form-control-editor"
      placeholder="Describe the must-have qualifications and skills needed for this job"
      formControlName="highLevelRequirements"
      data-cy="job-description-req-qualification-editor"
    >
    </mojo-editor>
  </div>

  <div class="mb-4">
    <label for="qualification">
      Preferred qualifications and skills
    </label>
    <mojo-editor
      id="qualification"
      [material]="true"
      [expandable]="true"
      class="form-control-editor"
      placeholder="Describe the nice-to-have qualifications and skills needed for this job"
      formControlName="qualification"
      data-cy="job-description-pref-qualification-editor"
    >
    </mojo-editor>
  </div>

  <div class="mb-4">
    <label for="education">
      Education
    </label>
    <mojo-editor
      id="education"
      [material]="true"
      [expandable]="true"
      class="form-control-editor"
      placeholder="Describe the education requirements"
      formControlName="education"
      data-cy="job-description-education-editor"
    >
    </mojo-editor>
  </div>

  <div class="mb-4">
    <label for="companyDescription">
      Company description
    </label>
    <mojo-editor
      id="companyDescription"
      [material]="true"
      [expandable]="true"
      class="form-control-editor description"
      placeholder="Describe your company and what makes it great"
      formControlName="companyDescription"
      data-cy="job-description-company-desc-editor"
    >
    </mojo-editor>
  </div>

  <div class="mb-4">
    <label for="additionalInformation">
      Additional info
    </label>
    <mojo-editor
      id="additionalInformation"
      [material]="true"
      [expandable]="true"
      class="form-control-editor"
      placeholder="Describe anything else you'd like candidates to know, such as company culture, perks and business goals"
      formControlName="additionalInformation"
      data-cy="job-description-add-info-editor"
    >
    </mojo-editor>
  </div>
</form>
